/**
 * Safari compatibility fixes focused specifically on image rendering during scroll
 * and smooth section navigation
 */

(function() {
  // Execute when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // Detect Safari specifically
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
      (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
    
    if (!isSafari) return; // Only run in Safari
    
    // Add Safari browser class
    document.body.classList.add('safari-browser');
    
    // Check if running in iframe 
    let isIframe = false;
    try {
      isIframe = window !== window.parent;
    } catch (e) {
      isIframe = true; // Cross-origin iframe
    }
    
    if (isIframe) {
      document.body.classList.add('safari-iframe');
    }
    
    // Check for iOS Safari
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      document.body.classList.add('ios-safari');
    }
    
    // Add special CSS for Safari modal image fixes
    const style = document.createElement('style');
    style.textContent = `
      /* Safari-specific image rendering fix - Applied directly via JS for specificity */
      .memorial-image {
        /* Fix Safari image rendering */
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        
        /* Force images to remain visible */
        opacity: 1 !important;
        visibility: visible !important;
        
        /* Prevent image flickering with better will-change hint */
        will-change: transform; 
        
        /* Render as a separate layer */
        z-index: 1;
        position: relative;
        
        /* Explicitly set painting properties */
        image-rendering: -webkit-optimize-contrast;
      }
      
      /* Override normal hover effects in Safari */
      .markdown-content img:hover {
        transform: none !important;
        -webkit-transform: translateZ(0) !important;
        filter: none !important;
      }
      
      /* Optimize modal scrolling in Safari */
      .info-modal {
        -webkit-overflow-scrolling: touch;
      }
      
      /* Improve Safari section scrolling */
      .section-content {
        transform: translateZ(0);
        -webkit-transform: translateZ(0);
      }
      
      /* Fix scrolling container for Safari */
      .scrollable-content {
        -webkit-overflow-scrolling: touch !important;
      }
      
      /* Smoother section headers */
      .wall-section h2 {
        transform: translateZ(0);
        -webkit-transform: translateZ(0);
      }
    `;
    document.head.appendChild(style);
    
    // Patch ReactMarkdown image rendering for Safari
    function patchImages() {
      // Wait for images to be loaded
      setTimeout(() => {
        const images = document.querySelectorAll('.memorial-image');
        if (images.length > 0) {
          images.forEach(img => {
            // Apply Safari-specific fixes to each image
            img.style.webkitTransform = 'translateZ(0)';
            img.style.transform = 'translateZ(0)';
            img.style.willChange = 'transform';
            
            // Force visibility (will be taken from cache if loaded)
            img.style.visibility = 'visible';
            img.style.opacity = '1';
            
            // DO NOT clone images - this causes errors
            // Just ensure loading is eager and image is visible
            img.loading = "eager";
            img.style.visibility = "visible";
            // Add a small nudge to trigger browser repaint without DOM manipulation
            setTimeout(() => {
              img.style.opacity = "0.99";
              setTimeout(() => {
                img.style.opacity = "1";
              }, 10);
            }, 0);
          });
        } else {
          // Try again if images aren't loaded yet
          setTimeout(patchImages, 500);
        }
      }, 200);
    }
    
    // Smooth out section changes
    function optimizeSectionChanges() {
      // Patch section headers for smoother transitions
      const sectionHeaders = document.querySelectorAll('.wall-section');
      sectionHeaders.forEach(section => {
        section.style.webkitTransform = 'translateZ(0)';
        section.style.transform = 'translateZ(0)';
      });
      
      // Optimize scrollable content
      const scrollContent = document.querySelector('.scrollable-content');
      if (scrollContent) {
        // Ensure Safari momentum scrolling is enabled
        scrollContent.style.webkitOverflowScrolling = 'touch';
      }
    }
    
    // Initial section optimization
    optimizeSectionChanges();
    
    // Handle modal openings
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          // Check if a modal was added
          if (document.querySelector('.modal-overlay')) {
            patchImages();
            break;
          }
        }
      }
    });
    
    // Start observing the document body for modal openings
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();